import { useState } from 'react'
import { router } from '@inertiajs/react'
import { useFlashToast } from '../../../hooks/useFlashToast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft, faXmark, faCrown, faUser, faUserTie,
  faCircleCheck, faCircleXmark, faPen, faTrash, faToggleOn, faToggleOff,
  faEnvelope, faPhone, faIdCard, faCalendar, faKey, faShield
} from '@fortawesome/free-solid-svg-icons'
import SuperadminSidebar from '../../../components/superadmin/Sidebar'
import SuperadminTopbar from '../../../components/superadmin/Topbar'

function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 w-full max-w-sm shadow-2xl">
        <p className="text-gray-200 text-sm mb-5">{message}</p>
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-gray-400 hover:text-gray-200 rounded-lg hover:bg-gray-700">Batal</button>
          <button onClick={onConfirm} className="px-4 py-2 text-sm font-semibold bg-red-600 hover:bg-red-500 text-white rounded-lg">Ya, lanjutkan</button>
        </div>
      </div>
    </div>
  )
}

function EditDrawer({ user, onClose }) {
  const [form, setForm] = useState({
    username: user.username, name: user.name || '', email: user.email,
    password: '', phone: user.phone || '', nik: user.nik || '',
    address: user.address || '', user_type: user.user_type
  })
  const [loading, setLoading] = useState(false)

  const submit = (e) => {
    e.preventDefault()
    setLoading(true)
    router.patch(`/superadmin/users/${user.id}`, { user: form }, {
      onFinish: () => { setLoading(false); onClose() }
    })
  }

  return (
    <div className="fixed inset-0 z-50 flex">
      <div className="flex-1 bg-black/60" onClick={onClose} />
      <div className="w-full max-w-md bg-gray-800 border-l border-gray-700 flex flex-col shadow-2xl overflow-y-auto">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-700 flex-shrink-0">
          <h3 className="font-semibold text-white">Edit Pengguna</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-300">
            <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
          </button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-4 flex-1">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Username *</label>
              <input required value={form.username} onChange={e => setForm({...form, username: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Nama Lengkap</label>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Email *</label>
            <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Password baru <span className="text-gray-600">(kosongkan jika tidak diubah)</span></label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">No. Telepon</label>
              <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">NIK</label>
              <input value={form.nik} onChange={e => setForm({...form, nik: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Alamat</label>
            <textarea rows={2} value={form.address} onChange={e => setForm({...form, address: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none resize-none" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Tipe Pengguna</label>
            <select value={form.user_type} onChange={e => setForm({...form, user_type: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none">
              <option value="external">External</option>
              <option value="internal">Internal</option>
            </select>
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2 text-sm text-gray-400 border border-gray-700 rounded-lg hover:bg-gray-700">Batal</button>
            <button type="submit" disabled={loading}
              className="flex-1 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg disabled:opacity-60">
              {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

function InfoRow({ icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center flex-shrink-0 mt-0.5">
        <FontAwesomeIcon icon={icon} className="w-3.5 h-3.5 text-gray-500" />
      </div>
      <div>
        <div className="text-[11px] text-gray-600 uppercase tracking-wide">{label}</div>
        <div className="text-sm text-gray-300 mt-0.5">{value || <span className="text-gray-600 italic">Tidak diisi</span>}</div>
      </div>
    </div>
  )
}

export default function SuperadminUsersShow({ current_user, user }) {
  useFlashToast()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [confirm, setConfirm] = useState(null)

  const toggleAdmin = () => {
    const action = user.admin ? 'mencabut role admin dari' : 'menjadikan admin'
    setConfirm({
      message: `Yakin ingin ${action} "${user.username}"?`,
      onConfirm: () => {
        router.patch(`/superadmin/users/${user.id}/toggle_admin`)
        setConfirm(null)
      }
    })
  }

  const toggleConfirmation = () => {
    const action = user.confirmed ? 'mencabut konfirmasi' : 'mengkonfirmasi'
    setConfirm({
      message: `Yakin ingin ${action} akun "${user.username}"?`,
      onConfirm: () => {
        router.patch(`/superadmin/users/${user.id}/toggle_confirmation`)
        setConfirm(null)
      }
    })
  }

  const deleteUser = () => {
    setConfirm({
      message: `Hapus pengguna "${user.username}"? Tindakan ini tidak dapat dibatalkan.`,
      onConfirm: () => {
        router.delete(`/superadmin/users/${user.id}`, {}, {
          onSuccess: () => router.visit('/superadmin/users')
        })
        setConfirm(null)
      }
    })
  }

  return (
    <div className="flex h-screen bg-gray-950 font-sans overflow-hidden text-gray-100">
      <SuperadminSidebar current_user={current_user} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <SuperadminTopbar current_user={current_user} onMenuToggle={() => setSidebarOpen(true)}>
          <a href="/superadmin/users" className="flex items-center gap-2 text-sm text-gray-400 hover:text-gray-200 transition-colors">
            <FontAwesomeIcon icon={faChevronLeft} className="w-3.5 h-3.5" />
            Manajemen Pengguna
          </a>
        </SuperadminTopbar>

        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <div className="max-w-4xl mx-auto space-y-6">
            {/* Profile card */}
            <div className="bg-gray-900 rounded-2xl border border-gray-800 p-6">
              <div className="flex items-start gap-5">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-xl font-bold flex-shrink-0 ${user.superadmin ? 'bg-indigo-900/60 text-indigo-400 ring-2 ring-indigo-600/40' : user.admin ? 'bg-violet-900/60 text-violet-400 ring-2 ring-violet-700/40' : 'bg-gray-800 text-gray-400'}`}>
                  {(user.name || user.username).slice(0, 2).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <h1 className="text-xl font-bold text-white">{user.name || user.username}</h1>
                    {user.superadmin && (
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-indigo-900/60 text-indigo-400 ring-1 ring-indigo-700/50">
                        <FontAwesomeIcon icon={faCrown} className="w-3 h-3" /> Superadmin
                      </span>
                    )}
                    {user.admin && !user.superadmin && (
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-violet-900/60 text-violet-400 ring-1 ring-violet-700/50">
                        <FontAwesomeIcon icon={faUserTie} className="w-3 h-3" /> Admin
                      </span>
                    )}
                    {!user.admin && !user.superadmin && (
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-gray-800 text-gray-400 ring-1 ring-gray-700">
                        <FontAwesomeIcon icon={faUser} className="w-3 h-3" /> User
                      </span>
                    )}
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ${user.confirmed ? 'bg-emerald-900/40 text-emerald-400 ring-emerald-700/50' : 'bg-amber-900/40 text-amber-400 ring-amber-700/50'}`}>
                      <FontAwesomeIcon icon={user.confirmed ? faCircleCheck : faCircleXmark} className="w-3 h-3" />
                      {user.confirmed ? 'Terverifikasi' : 'Belum Diverifikasi'}
                    </span>
                  </div>
                  <p className="text-gray-500 text-sm mt-1">@{user.username} · {user.user_type}</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <button onClick={() => setShowEdit(true)}
                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-lg transition-colors">
                    <FontAwesomeIcon icon={faPen} className="w-3.5 h-3.5" /> Edit
                  </button>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Info detail */}
              <div className="lg:col-span-2 space-y-6">
                <div className="bg-gray-900 rounded-2xl border border-gray-800 p-6">
                  <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-5">Informasi Akun</h2>
                  <div className="space-y-4">
                    <InfoRow icon={faEnvelope} label="Email" value={user.email} />
                    <InfoRow icon={faPhone}    label="Telepon" value={user.phone} />
                    <InfoRow icon={faIdCard}   label="NIK" value={user.nik} />
                    <InfoRow icon={faCalendar} label="Bergabung" value={user.created_at} />
                    <InfoRow icon={faCalendar} label="Terakhir Login" value={user.last_sign_in_at || '—'} />
                    <InfoRow icon={faKey}      label="Total Login" value={user.sign_in_count != null ? `${user.sign_in_count}x` : '—'} />
                  </div>
                </div>

                {user.address && (
                  <div className="bg-gray-900 rounded-2xl border border-gray-800 p-6">
                    <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3">Alamat</h2>
                    <p className="text-sm text-gray-300 leading-relaxed">{user.address}</p>
                  </div>
                )}
              </div>

              {/* Actions sidebar */}
              <div className="space-y-4">
                {/* Role toggle */}
                {!user.superadmin && (
                  <div className="bg-gray-900 rounded-2xl border border-gray-800 p-5">
                    <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">Role</h2>
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="text-sm font-medium text-gray-200">{user.admin ? 'Admin' : 'User Biasa'}</div>
                        <div className="text-xs text-gray-500 mt-0.5">{user.admin ? 'Memiliki akses admin' : 'Pengguna reguler'}</div>
                      </div>
                      <button onClick={toggleAdmin}
                        className={`p-1 rounded-lg transition-colors ${user.admin ? 'text-indigo-400 hover:text-gray-400' : 'text-gray-600 hover:text-indigo-400'}`}>
                        <FontAwesomeIcon icon={user.admin ? faToggleOn : faToggleOff} className="w-7 h-7" />
                      </button>
                    </div>
                  </div>
                )}

                {/* Confirmation */}
                <div className="bg-gray-900 rounded-2xl border border-gray-800 p-5">
                  <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">Verifikasi Email</h2>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm font-medium text-gray-200">{user.confirmed ? 'Terverifikasi' : 'Belum Verifikasi'}</div>
                      <div className="text-xs text-gray-500 mt-0.5">{user.confirmed_at || '—'}</div>
                    </div>
                    <button onClick={toggleConfirmation}
                      className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors ${user.confirmed ? 'bg-amber-900/40 text-amber-400 hover:bg-amber-900/60' : 'bg-emerald-900/40 text-emerald-400 hover:bg-emerald-900/60'}`}>
                      <FontAwesomeIcon icon={user.confirmed ? faCircleXmark : faCircleCheck} className="w-3.5 h-3.5" />
                      {user.confirmed ? 'Cabut' : 'Verifikasi'}
                    </button>
                  </div>
                </div>

                {/* Danger zone */}
                {!user.superadmin && (
                  <div className="bg-gray-900 rounded-2xl border border-red-900/40 p-5">
                    <h2 className="text-sm font-semibold text-red-500 uppercase tracking-wider mb-4 flex items-center gap-2">
                      <FontAwesomeIcon icon={faShield} className="w-3.5 h-3.5" /> Danger Zone
                    </h2>
                    <p className="text-xs text-gray-500 mb-3">Hapus akun pengguna ini secara permanen. Tindakan tidak dapat dibatalkan.</p>
                    <button onClick={deleteUser}
                      className="w-full flex items-center justify-center gap-2 py-2 px-3 text-sm font-semibold text-red-400 bg-red-900/20 hover:bg-red-900/40 rounded-lg transition-colors border border-red-900/40">
                      <FontAwesomeIcon icon={faTrash} className="w-3.5 h-3.5" />
                      Hapus Pengguna
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      {showEdit && <EditDrawer user={user} onClose={() => setShowEdit(false)} />}
      {confirm && <ConfirmModal message={confirm.message} onConfirm={confirm.onConfirm} onCancel={() => setConfirm(null)} />}
    </div>
  )
}
